import React, { useState, useRef } from 'react';
import { Button, Row, Col, message, ConfigProvider, Modal } from 'antd';
import zhCN from 'antd/lib/locale/zh_CN';
import _, { isEmpty } from 'lodash-es';
import track from '../utils.ts';
import dayjs from 'dayjs';
import config from './kjlAccountConfig';
import {httpOrgList} from "@/services/homeService.ts";
import {SFuncModal, SLowcodeList} from "shj-components";
import {dcpDesignInfoSearchOwnerCompany} from "@/services/kuAccount.ts";
import {apiData2Table} from "@/utils/data.ts";

export function modalBindingKjlAccountModelFn(props: any) {
  const { onClose, fn, ...rest } = props;
  const { flag, msg } = rest;
  if (flag == true) {
    Modal.info({
      title: '选择酷家乐账号',
      content: msg,
      onOk() {},
      okText: '是',
    });
  } else {
    if (!isEmpty(rest.trackParams)) {
      track('task_page_view', {
        enter_time: dayjs().format('YYYY-MM-DD HH:mm:ss.SSS'),
        ...rest.trackParams,
      });
    }
    const onClose = () => {
      if (!isEmpty(rest.trackParams)) {
        track('task_page_close', {
          leave_time: dayjs().format('YYYY-MM-DD HH:mm:ss.SSS'),
          ...rest.trackParams,
        });
      }
      dialog.destroy();
    };

    const dialog = SFuncModal({
      title: `选择酷家乐账号`,
      vanish: true,
      width: 1000,
      // getContainer: false,
      onCancel: () => {
        onClose();
      },
      content: (
        <ConfigProvider locale={zhCN}>
          <ModalBindingKjlAccountModelDom onClose={onClose} fn={fn} {...rest} msg={msg} />
        </ConfigProvider>
      ),
    });

    return dialog;
  }
}

const ModalBindingKjlAccountModelDom = (props: any) => {
  const { onClose, fn, ...rest } = props;
  const listRef = useRef<any>();
  const [submitLoading, setSubmitLoading] = useState<boolean>(false);

  const fetchList = (values: { current: number; pageSize: number; query: Record<string, any> }) => {
    return new Promise((resolve, reject) => {
      try {
        const { current, pageSize, query } = values;
        dcpDesignInfoSearchOwnerCompany(current, pageSize, query).then(resp => {
            resolve(apiData2Table(resp));
        })
      } catch (e) {
        reject({ success: false });
      }
    });
  };

  // 获取下拉
  const getSelection = () => {
    return new Promise((resolve) => {
      Promise.all([httpOrgList()]).then((resp) => {
        const listObj = {
          companies: resp[0],
        };
        resolve(listObj);
      });
    });
  };

  const handleSubmit = () => {
    const selectedRowsObj = listRef.current.getSelectedRows()[1][0];
    if (!selectedRowsObj) return message.error('请选择酷家乐账号！');
    onClose && onClose();
    fn && fn(selectedRowsObj);
    console.log('酷家乐账号', selectedRowsObj);
  };
  const extension = {
    request: { fetchList, getSelection },
    customRender: {
      timeRender(text: any, record: any) {
        return dayjs(text).format('YYYY-MM-DD HH:mm:ss');
      },
    },
  };
  return (
    <SFuncModal.Content
        onCancel={onClose}
        onOk={handleSubmit}
        okText={'确认'}
    >
      <SLowcodeList searchMode={'group'} config={config} ref={listRef} {...extension} rowKey={'id'} />
    </SFuncModal.Content>
  );
};
